import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import styled from "styled-components";
import "../Styles/global.css";
import "../Styles/component.css";
import { ReactComponent as IconPlus } from "../Images/icon_plus.svg";
import { useState, useEffect } from "react";
import ToastAlarm from "../Components/ToastAlarm";
import AlarmSimpleOk from "./AlarmSimpleOk";
import AlarmCancel from "./AlarmCancel";
import { postJson } from "../Utils/apiUtils";

const DepartmentManage = ({ handleCloseDepartmentModal }) => {
  const [addDepartmentName, setAddDepartmentName] = useState("");
  const [editDepartment, setEditDepartment] = useState({
    id: null,
    name: "",
  });
  const [addInputState, setAddInputState] = useState({
    active: false,
    type: "", // "", "focus", "error"
  });
  const [editInputState, setEditInputState] = useState({
    active: false,
    type: "", // "focus", "error"
  });
  const [toast, setToast] = useState({
    show: false,
    type: "", // add, delete, edit, error
  });
  const [modal, setModal] = useState({
    show: false,
    type: "", // maxNum, delete
  });
  const [departmentList, setDepartmentList] = useState([]);
  const [targetId, setTargetId] = useState(0);
  const [draggingDepartmentId, setDraggingDepartmentId] = useState(null);
  const [dragOverDepartmentId, setDragOverDepartmentId] = useState(null);
  const [isSavingOrder, setIsSavingOrder] = useState(false);

  const registeredCount = departmentList.length;
  const MAX_DEPARTMENT_NUM = 30;
  const MAX_DEPARTMENT_LENGTH = 20;

  const moveDepartment = (list, sourceId, targetId) => {
    const sourceIndex = list.findIndex(
      (department) => department.companyDepartmentId === sourceId
    );
    const targetIndex = list.findIndex(
      (department) => department.companyDepartmentId === targetId
    );

    if (
      sourceIndex === -1 ||
      targetIndex === -1 ||
      sourceIndex === targetIndex
    ) {
      return list;
    }

    const nextList = [...list];
    const [draggedDepartment] = nextList.splice(sourceIndex, 1);
    nextList.splice(targetIndex, 0, draggedDepartment);

    return nextList;
  };

  const resetDragState = () => {
    setDraggingDepartmentId(null);
    setDragOverDepartmentId(null);
  };

  // 부서 리스트
  const getDepartmentList = async () => {
    try {
      const res = await postJson("/dashboard/department/getList", {});
      if (res.code === 200) {
        setDepartmentList(res.data.rows);
      } else {
        console.error("부서 리스트 불러오기 실패:", res);
      }
    } catch (error) {
      console.error("부서 리스트 가져오기 중 에러", error);
    }
  };

  useEffect(() => {
    getDepartmentList();
  }, []);

  // 부서 등록
  const handleAddDepartment = async () => {
    if (departmentList.length >= MAX_DEPARTMENT_NUM) {
      setModal({ show: true, type: "maxNum" });
    } else {
      const departmentName = addDepartmentName;
      try {
        const body = { departmentName };
        const res = await postJson("/dashboard/department/create", body);
        if (res.code === 200) {
          getDepartmentList();
          setToast({
            show: true,
            type: "add",
          });
        } else {
          console.error("부서 등록 실패:", res);
        }
      } catch (error) {
        console.error("부서 등록 중 에러", error);
      }
    }
    setAddDepartmentName("");
  };

  // 부서 삭제
  const handleDelDepartment = async () => {
    try {
      const body = { companyDepartmentId: targetId };
      const res = await postJson("/dashboard/department/delete", body);
      if (res.code === 200) {
        getDepartmentList();
        setModal({
          show: false,
          type: "delete",
        });
        setToast({
          show: true,
          type: "delete",
        });
      } else {
        console.error("부서 삭제 실패:", res);
      }
    } catch (error) {
      console.error("부서 삭제 중 에러", error);
    }
    setTargetId(0);
  };

  const handleActiveDelModal = () => {
    setModal({ show: true, type: "delete" });
  };

  const isDuplicatedDepartment = (name) => {
    const normalizedValue = String(name).toLowerCase();

    return departmentList.some(
      (dept) => String(dept.departmentName).toLowerCase() === normalizedValue
    );
  };

  const handleAddInputChange = (e) => {
    const value = e.target.value;
    const isError = isDuplicatedDepartment(value);

    setAddDepartmentName(value);
    setAddInputState({
      type: isError ? "error" : "focus",
      active: true,
    });
  };

  const handleEditInputChange = (e) => {
    const value = e.target.value;
    const isError = isDuplicatedDepartment(value);

    setEditDepartment((prev) => ({
      ...prev,
      name: value,
    }));

    setEditInputState({
      type: isError ? "error" : "focus",
      active: true,
    });
  };

  const handleDisabledEdit = () => {
    setEditDepartment({
      id: null,
      name: "",
    });
  };

  // API 부서 편집
  const handleEditDepartment = async () => {
    const companyDepartmentId = editDepartment.id;
    const departmentName = editDepartment.name;
    const isDuplicate = departmentList.some(
      (dept) => dept.departmentName.trim() === departmentName
    );
    if (isDuplicate) {
      setEditDepartment({ id: null, name: "" });
      return;
    }

    try {
      const body = { companyDepartmentId, departmentName };
      const res = await postJson("/dashboard/department/update", body);

      if (res.code === 200) {
        getDepartmentList();
        setEditDepartment({ id: null, name: "" });
        setEditInputState({ type: "", active: false });
        setToast({
          show: true,
          type: "edit",
        });
      } else {
        setToast({
          show: true,
          type: "error",
        });
        console.error("부서 편집 실패", res);
      }
    } catch (error) {
      console.error("부서 편집 중 에러", error);
    }
  };

  const handleUpdateDepartmentOrder = async (nextDepartmentList) => {
    try {
      setIsSavingOrder(true);
      setDepartmentList(nextDepartmentList);

      const orderedDepartmentIds = nextDepartmentList.map(
        (department) => department.companyDepartmentId
      );
      const res = await postJson("/dashboard/department/updateOrder", {
        orderedDepartmentIds,
      });

      if (res.code === 200) {
        setToast({
          show: true,
          type: "reorder",
        });
      } else {
        await getDepartmentList();
        setToast({
          show: true,
          type: "error",
        });
        console.error("부서 순서 저장 실패:", res);
      }
    } catch (error) {
      await getDepartmentList();
      setToast({
        show: true,
        type: "error",
      });
      console.error("부서 순서 저장 중 에러", error);
    } finally {
      setIsSavingOrder(false);
      resetDragState();
    }
  };

  const handleDragStart = (companyDepartmentId) => {
    if (editDepartment.id !== null || isSavingOrder) {
      return;
    }

    setDraggingDepartmentId(companyDepartmentId);
    setDragOverDepartmentId(companyDepartmentId);
  };

  const handleDragOver = (e, companyDepartmentId) => {
    if (!draggingDepartmentId || draggingDepartmentId === companyDepartmentId) {
      return;
    }

    e.preventDefault();
    setDragOverDepartmentId(companyDepartmentId);
  };

  const handleDrop = async (companyDepartmentId) => {
    if (
      !draggingDepartmentId ||
      draggingDepartmentId === companyDepartmentId ||
      isSavingOrder
    ) {
      resetDragState();
      return;
    }

    const nextDepartmentList = moveDepartment(
      departmentList,
      draggingDepartmentId,
      companyDepartmentId
    );

    await handleUpdateDepartmentOrder(nextDepartmentList);
  };

  return (
    <>
      {toast.show && (
        <div
          className="page-wrapper center"
          style={{
            backgroundColor: "transparent",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          {toast.type === "add" && (
            <ToastAlarm
              message={"부서명이 등록되었습니다."}
              setToast={setToast}
              type={"success"}
            />
          )}
          {toast.type === "delete" && (
            <ToastAlarm
              message={"부서가 삭제되었습니다."}
              setToast={setToast}
              type={"success"}
            />
          )}
          {toast.type === "edit" && (
            <ToastAlarm
              message={"부서명이 수정되었습니다."}
              setToast={setToast}
              type={"success"}
            />
          )}
          {toast.type === "reorder" && (
            <ToastAlarm
              message={"부서 순서가 저장되었습니다."}
              setToast={setToast}
              type={"success"}
            />
          )}
          {toast.type === "error" && (
            <ToastAlarm
              message={"다시 한 번 시도해주세요."}
              setToast={setToast}
              type={"error"}
            />
          )}
        </div>
      )}

      <Box>
        <BoxContainer>
          <TitleLayout>
            <h1 className="hrz-wrapper" style={{ fontSize: "24px" }}>
              부서 관리
            </h1>
            <IconCrossRound
              onClick={handleCloseDepartmentModal}
              style={{ marginLeft: "auto", cursor: "pointer" }}
            />
          </TitleLayout>
          <div>
            <InputLayout>
              <div
                className="textinputBox"
                style={{
                  width: "100%",
                  padding: "16px 14px",
                  alignItems: "center",
                  border: `1px solid ${
                    addInputState.type === "error"
                      ? "#F25C5C"
                      : addInputState.type === "focus"
                      ? "#1167ED"
                      : "#E4E4E4"
                  }`,
                }}
              >
                <StyledInput
                  type="text"
                  placeholder="부서명을 입력해주세요."
                  value={addDepartmentName}
                  onChange={handleAddInputChange}
                  maxLength={MAX_DEPARTMENT_LENGTH}
                  onFocus={() =>
                    setAddInputState({ type: "focus", active: true })
                  }
                  onBlur={() =>
                    setAddInputState((prev) => ({
                      ...prev,
                      type: prev.type === "error" ? "error" : "",
                      active: false,
                    }))
                  }
                />
                <div style={{ color: "#B0B0B0", marginLeft: "auto" }}>
                  {addDepartmentName.length}/{MAX_DEPARTMENT_LENGTH}
                </div>
              </div>
              <AddBtn
                onClick={handleAddDepartment}
                $addDepartmentName={addDepartmentName}
                disabled={
                  addInputState.type === "error" ||
                  addDepartmentName.length === 0
                }
              >
                <IconPlus width="20px" stroke="#FFFFFF" />
                추가
              </AddBtn>
            </InputLayout>
            {addInputState.type === "error" && (
              <ErrorMsg>동일한 부서명이 있어요!</ErrorMsg>
            )}
          </div>

          <DepartmentCardContainer>
            <TotalDepartment>
              전체{registeredCount}/{MAX_DEPARTMENT_NUM}
            </TotalDepartment>
            <DepartmentGuide>
              부서를 드래그해서 순서를 변경할 수 있어요.
            </DepartmentGuide>
            {departmentList.map((data, index) =>
              editDepartment.id === data.companyDepartmentId ? (
                <div key={data.companyDepartmentId}>
                  <EditCard>
                    <p style={{ color: "#888", fontWeight: "700" }}>
                      {index + 1}
                    </p>
                    <InputLayout>
                      <div
                        className="textinputBox"
                        style={{
                          width: "100%",
                          padding: "16px 14px",
                          alignItems: "center",
                          border: `1px solid ${
                            editInputState.type === "error"
                              ? "#F25C5C"
                              : editInputState.type === "focus"
                              ? "#1167ED"
                              : "#E4E4E4"
                          }`,
                        }}
                      >
                        <StyledInput
                          type="text"
                          value={editDepartment.name}
                          onChange={handleEditInputChange}
                          maxLength={MAX_DEPARTMENT_LENGTH}
                          onFocus={() =>
                            setEditInputState({ type: "focus", active: true })
                          }
                          onBlur={() =>
                            setEditInputState((prev) => ({
                              ...prev,
                              type: prev.type === "error" ? "error" : "",
                              active: false,
                            }))
                          }
                        />
                        <div style={{ color: "#B0B0B0", marginLeft: "auto" }}>
                          {editDepartment.name.length}/{MAX_DEPARTMENT_LENGTH}
                        </div>
                      </div>
                    </InputLayout>
                    <BtnWrapper>
                      <Btn onClick={handleDisabledEdit}>
                        <p>취소</p>
                      </Btn>
                      <Btn
                        disabled={
                          editDepartment.name === "" ||
                          editInputState.type === "error"
                        }
                        onClick={handleEditDepartment}
                        style={{
                          color: "#FFFFFF",
                          borderRadius: "8px",
                          background:
                            editDepartment.name !== "" ? "#1167ED" : "#C5DAFA",
                        }}
                      >
                        <p>저장</p>
                      </Btn>
                    </BtnWrapper>
                  </EditCard>
                  {editInputState.type === "error" && (
                    <ErrorMsg style={{ margin: "0 44px " }}>
                      동일한 부서명이 있어요!
                    </ErrorMsg>
                  )}
                </div>
              ) : (
                <DepartmentCard
                  key={data.companyDepartmentId}
                  draggable={!isSavingOrder && editDepartment.id === null}
                  $isDragging={draggingDepartmentId === data.companyDepartmentId}
                  $isDropTarget={dragOverDepartmentId === data.companyDepartmentId}
                  onDragStart={() => handleDragStart(data.companyDepartmentId)}
                  onDragOver={(e) => handleDragOver(e, data.companyDepartmentId)}
                  onDrop={() => handleDrop(data.companyDepartmentId)}
                  onDragEnd={resetDragState}
                >
                  <DragHandleWrapper>
                    <DragHandleMark>=</DragHandleMark>
                  </DragHandleWrapper>
                  <OrderNumber>{index + 1}</OrderNumber>
                  <NameWrapper>
                    <p>{data.departmentName}</p>
                    {data.userCount > 0 ? (
                      <MemberNumN>{data.userCount}명</MemberNumN>
                    ) : (
                      <MemberNum0>{data.userCount}명</MemberNum0>
                    )}
                  </NameWrapper>
                  <BtnWrapper>
                    <Btn
                      onClick={() => {
                        setTargetId(data.companyDepartmentId);
                        handleActiveDelModal();
                      }}
                      style={{ color: "#F25C5C" }}
                    >
                      <p>삭제</p>
                    </Btn>
                    <Btn
                      onClick={() => {
                        setEditDepartment({
                          id: data.companyDepartmentId,
                          name: data.departmentName,
                        });
                      }}
                      style={{
                        borderRadius: "10px",
                        border: "1px solid #D9D9D9",
                      }}
                    >
                      <p>편집</p>
                    </Btn>
                  </BtnWrapper>
                </DepartmentCard>
              )
            )}
          </DepartmentCardContainer>

          {registeredCount === 0 ? <Empty>등록된 부서가 없습니다.</Empty> : ""}
          {modal.show &&
            (modal.type === "maxNum" ? (
              <AlarmSimpleOk
                title={"최대 30개까지 등록 가능합니다."}
                handleClickX={() => {
                  setModal({ show: false, type: "" });
                }}
              />
            ) : (
              <AlarmCancel
                title="부서를 삭제하시겠습니까?"
                subtitle="삭제 시 구성원이 앱 내에서 등록한 부서정보도 삭제됩니다."
                handleClickX={() => {
                  setModal({
                    show: false,
                    type: "",
                  });
                }}
                handleCancel={handleDelDepartment}
              />
            ))}
        </BoxContainer>
      </Box>
    </>
  );
};

export default DepartmentManage;

const Box = styled.div`
  z-index: 1;
  position: absolute;
  height: 646px;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const BoxContainer = styled.div`
  display: flex;
  width: 620px;
  flex-direction: column;
  gap: 30px;
`;

const TitleLayout = styled.div`
  display: flex;
  align-items: center;
`;

const InputLayout = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;

  width: 100%;
  &: focus {
    border: 1px solid #1167ed;
  }
`;

const StyledInput = styled.input`
  all: unset;
  width: 100%;
  height: 22px;
  color: #222222;
  border: none;
  &: focus {
    outline: none;
  }
  &::placeholder {
    color: #b0b0b0;
  }
`;

const AddBtn = styled.button`
  all: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 80px;
  padding: 8px 14px 8px 12px;
  border-radius: 8px;
  background: ${({ $addDepartmentName = "", $addInputState }) =>
    $addDepartmentName.length > 0 ? "#1167ED" : "#c5dafa"};
  cursor: ${({ disabled }) => (disabled ? "" : "pointer")};

  color: #fff;
`;

const ErrorMsg = styled.p`
  margin-top: 8px;
  color: #f25c5c;
  font-weight: 400;
`;

const Empty = styled.p`
  text-align: center;
  margin-top: 200px;
  color: #888;
`;

const TotalDepartment = styled.div`
  margin-bottom: 4px;
  color: #222;
  font-weight: 400;
`;

const DepartmentGuide = styled.p`
  margin: -6px 0 4px;
  color: #888;
  font-size: 13px;
`;

const DepartmentCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  max-height: 400px;
  overflow: scroll;
  /* 크롬, 사파리 */
  &::-webkit-scrollbar {
    display: none;
  }

  /* 파이어폭스 */
  scrollbar-width: none;
`;

const EditCard = styled.div`
  display: flex;
  padding: 5px 20px;
  justify-content: center;
  align-items: center;
  gap: 14px;
  font-weight: 500;
`;

const DepartmentCard = styled.div`
  display: flex;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 14px;

  border-radius: 10px;
  border: 1px solid
    ${({ $isDropTarget }) => ($isDropTarget ? "#1167ed" : "#d9d9d9")};
  background: ${({ $isDragging }) => ($isDragging ? "#eef4ff" : "#f6f6f6")};
  font-weight: 500;
  cursor: grab;
`;

const DragHandleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  flex-shrink: 0;
  color: #8e96a0;
`;

const DragHandleMark = styled.span`
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
`;

const OrderNumber = styled.p`
  width: 18px;
  flex-shrink: 0;
  color: #888;
  font-weight: 700;
  text-align: center;
`;

const NameWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 10px;

  width: 100%;

  > p {
    min-width: 0;
    line-height: 1.4;
    word-break: break-word;
  }
`;

const MemberNum0 = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  padding: 4px 10px;
  color: #8c8c8c;
  border-radius: 8px;
  background: #d8dce2;
`;

const MemberNumN = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  padding: 4px 10px;
  color: #1167ed;
  border-radius: 8px;
  background: #c5dafa;
`;

const BtnWrapper = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 500;
  align-self: center;
  flex-shrink: 0;
`;

const Btn = styled.button`
  all: unset;
  width: 46px;
  height: 36px;
  text-align: center;

  font-size: 14px;
  color: #222;
  cursor: ${({ disabled }) => (disabled ? "" : "pointer")};
`;
